import i18n from 'i18n-react';

import en from './locales/en';

const locales = {
  en,
};

export default i18n.setTexts(locales.en);
